export default function IosColorFilterOutline() {
  return (
    <div
      className="ion-icon-ios-color-filter-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M366.195,212.122c1.185-6.528,1.806-13.252,1.806-20.122c0-61.856-50.145-112.001-112.001-112.001
	S143.999,130.144,143.999,192c0,6.87,0.621,13.594,1.806,20.122C98.616,225.302,63.999,268.606,63.999,320
	c0,61.856,50.145,112.001,112.001,112.001c31.342,0,59.671-12.879,80-33.627c20.329,20.748,48.658,33.627,80,33.627
	c61.856,0,112.001-50.145,112.001-112.001C448.001,268.606,413.384,225.303,366.195,212.122z M159.999,192
	c0-52.935,43.065-96.001,96.001-96.001s96.001,43.066,96.001,96.001c0,5.776-0.513,11.435-1.495,16.933
	c-4.749-0.614-9.59-0.934-14.506-0.934c-31.342,0-59.671,12.879-80,33.627c-20.329-20.748-48.658-33.627-80-33.627
	c-4.916,0-9.757,0.319-14.506,0.934C160.512,203.435,159.999,197.776,159.999,192z M272.001,320c0,19.58-5.896,37.806-16.001,53.006
	c-10.104-15.2-16.001-33.426-16.001-53.006c0-5.776,0.513-11.435,1.495-16.933c4.749,0.614,9.59,0.934,14.506,0.934
	s9.757-0.319,14.506-0.934C271.488,308.565,272.001,314.224,272.001,320z M256,288.001c-3.484,0-6.925-0.191-10.314-0.556
	c2.626-7.262,6.105-14.119,10.314-20.451c4.21,6.332,7.688,13.189,10.314,20.451C262.925,287.81,259.484,288.001,256,288.001z
	 M229.791,284.364c-29.756-8.455-53.666-30.937-64.105-59.81c3.39-0.364,6.83-0.556,10.314-0.556
	c27.353,0,52.069,11.5,69.572,29.917C238.847,263.104,233.484,273.351,229.791,284.364z M266.428,253.917
	c17.503-18.418,42.219-29.918,69.572-29.918c3.484,0,6.925,0.191,10.314,0.556c-10.439,28.873-34.35,51.354-64.105,59.81
	C278.516,273.351,273.153,263.104,266.428,253.917z M176,416.001c-52.936,0-96.001-43.065-96.001-96.001
	c0-43.852,29.555-80.931,69.792-92.364c11.732,34.983,40.265,62.257,76.014,72.243c-1.185,6.527-1.806,13.252-1.806,20.121
	c0,24.717,8.013,47.559,21.573,66.084C228.069,404.501,203.353,416.001,176,416.001z M336,416.001
	c-27.354,0-52.069-11.5-69.572-29.918c13.561-18.524,21.573-41.366,21.573-66.083c0-6.869-0.621-13.594-1.806-20.121
	c35.749-9.986,64.281-37.26,76.014-72.243c40.237,11.434,69.792,48.513,69.792,92.364C432.001,372.936,388.936,416.001,336,416.001z
	"/>
</svg>
`,
      }}
    />
  )
}
